import Error from '@/views/Error'

export default [
  {
    path: '/403',
    name: '403',
    component: Error,
    props: { code: 403 }
  },
  {
    path: '/404',
    name: '404',
    component: Error,
    props: { code: 404 }
  },
  {
    path: '/error',
    name: 'error',
    component: Error,
    props: { code: 500 }
  },
  {
    path: '*',
    redirect: { name: '404' }
  }
]
